import React, { useState, useEffect } from 'react';
import TradePortal from './components/TradePortal';
import AdminPanel from './components/AdminPanel';
import MigrationsPage from './components/MigrationsPage';
import './index.css';

function App() {
  const [currentView, setCurrentView] = useState('portal'); // 'portal', 'admin', or 'migrations'

  useEffect(() => {
    // Check URL path and set the appropriate view
    const path = window.location.pathname;
    const hash = window.location.hash;
    
    if (path.includes('migrations') || hash === '#migrations') {
      setCurrentView('migrations');
    } else if (path.includes('admin') || hash === '#admin') {
      setCurrentView('admin');
    } else {
      setCurrentView('portal');
    }

    // Listen for URL changes
    const handleLocationChange = () => {
      const newPath = window.location.pathname;
      const newHash = window.location.hash;
      
      if (newPath.includes('migrations') || newHash === '#migrations') {
        setCurrentView('migrations');
      } else if (newPath.includes('admin') || newHash === '#admin') {
        setCurrentView('admin');
      } else {
        setCurrentView('portal');
      }
    };

    window.addEventListener('popstate', handleLocationChange);
    window.addEventListener('hashchange', handleLocationChange);
    
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('hashchange', handleLocationChange);
    };
  }, []);

  // Render the appropriate component based on current view
  const renderView = () => {
    switch (currentView) {
      case 'migrations':
        return <MigrationsPage />;
      case 'admin':
        return <AdminPanel />;
      case 'portal':
      default:
        return <TradePortal />;
    }
  };

  return (
    <div className="App">
      {renderView()}
      
      {/* Admin access button (hidden, bottom right) - only show on portal view */}
      {currentView === 'portal' && (
        <button
          onClick={() => {
            setCurrentView('admin');
            window.history.pushState({}, '', '/admin');
          }}
          className="fixed bottom-4 right-4 w-3 h-3 opacity-0 hover:opacity-10"
          title="Admin Access"
        />
      )}
    </div>
  );
}

export default App;